import React from 'react'
import { string, object } from 'prop-types'
import triggerEvent from 'utils/dataLayer'

import BaseSocmedIcon from 'components/atoms/BaseSocmedIcon'
import AdmissionRegistrationButton from 'components/molecules/AdmissionRegistrationButton'
import AdmissionDownloadBrochure from 'components/molecules/AdmissionDownloadBrochure'

const SchoolPageBannerContent = ({
  registrationUrl,
  brochure,
  socialMedia,
}) => (
  <>
    <div className="school-page-banner__actions">
      {
        registrationUrl &&
        <AdmissionRegistrationButton type="campus" />
      }
      {
        brochure &&
        <AdmissionDownloadBrochure />
      }
    </div>
    {
      socialMedia &&
      <div className="school-page-banner__socmeds">
        {
          Object.keys(socialMedia).map((type, idx) => (
            socialMedia[type] &&
            <BaseSocmedIcon
              onClick={() => triggerEvent(`ga/campus/button-social/${type}`)}
              url={socialMedia[type]}
              type={type}
              key={`scm-icon-${idx}`}
            />
          ))
        }
      </div>
    }
    <style jsx>
      {`
        .school-page-banner{
          &__actions {
            margin: 16px -8px 0;
          }
          :global(&__button) {
            font-size: 14px;
            font-weight: bold;
            box-shadow: 0 2px 4px 0 rgba(107, 143, 188, 0.85);
            padding: 14px 28px;
            border: none;
            margin: 8px;
            width: 100%;
            @media screen and (min-width: 768px) {
              width: unset;
            }
          }
          &__socmeds {
            margin: 16px -4px;
          }
        }
      `}
    </style>
  </>
)

SchoolPageBannerContent.propTypes = {
  registrationUrl: string,
  brochure: string,
  socialMedia: object,
}

export default SchoolPageBannerContent
